import { render, staticRenderFns } from "./ConfigSnapshotCard.vue?vue&type=template&id=8004423e&scoped=true&"
import script from "./ConfigSnapshotCard.vue?vue&type=script&lang=js&"
export * from "./ConfigSnapshotCard.vue?vue&type=script&lang=js&"
import style0 from "./ConfigSnapshotCard.vue?vue&type=style&index=0&id=8004423e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8004423e",
  null
  
)

export default component.exports